export default{

    measures:{
        importCsv: 'Εισαγωγή από λιπομετρητή',
        chooseFatMeter: 'Επιλέξτε λιπομετρητή',
    }
}